import React from 'react';
import { colors } from 'design-system';
import { makeStyles, Snackbar, Button } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  buttonSnackbar: {
    boxShadow: 'none',
    color: colors.bright_turquoise,
  },
}));

type Props = {
  open: boolean;
  message: string;
  onClose: () => void;
};

export const SnackbarMessage = ({
  open,
  message,
  onClose,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Snackbar
      data-testid="snackbar"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={5000}
      open={open}
      message={message}
      onClose={onClose}
      action={
        <Button
          className={classes.buttonSnackbar}
          color="secondary"
          variant="contained"
          data-testid="close-snackbar-button"
          size="small"
          onClick={onClose}
          type="button"
        >
          Entendido
        </Button>
      }
    />
  );
};

export default SnackbarMessage;
